module.exports = __webpack_public_path__ + "static/media/antano-pan-diario-80g-1920x1080.712df5f2.webp";